import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import React, { useEffect, useCallback } from 'react';
import AnticheatDashboard from '../components/anticheat';
import * as anticheatActions from '../redux/actions/anticheatActions';

const AnticheatPageContainer = ({
  anticheat,
  actions,
  userId,
}) => {
  useEffect(() => {
    if (!userId) return;
    actions.fetchFlaggedPlayers({ userId });
  }, [userId]);

  const handleSelectPlayer = useCallback(
    (steamId) => {
      if (!userId || !steamId) return;
      actions.fetchPlayerSummary({ steamId, userId });
      actions.fetchPlayerObservations({ steamId, userId });
    },
    [actions, userId]
  );

  const handleClearPlayer = useCallback(() => {
    actions.clearSelectedPlayer();
  }, [actions]);

  const handleRefresh = useCallback(() => {
    if (!userId) return;
    actions.fetchFlaggedPlayers({ userId });
  }, [actions, userId]);

  return (
    <AnticheatDashboard
      loading={anticheat.loading}
      error={anticheat.error}
      flaggedPlayers={anticheat.flaggedPlayers}
      selectedPlayer={anticheat.selectedPlayer}
      selectedPlayerSummary={anticheat.selectedPlayerSummary}
      selectedPlayerObservations={anticheat.selectedPlayerObservations}
      onSelectPlayer={handleSelectPlayer}
      onClearPlayer={handleClearPlayer}
      onRefresh={handleRefresh}
    />
  );
};

const mapStateToProps = (state) => ({
  anticheat: state.anticheat,
  userId: state.catalogReducer?.user?.userId,
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(anticheatActions, dispatch),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AnticheatPageContainer);
